module.exports = __webpack_public_path__ + "assets/ddd75e37bc06711b58c480d4311558f3.mp3";